
import { Vue, Component } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";

@Component({
  components: {
    VueRecaptcha
  }
})
export default class extends Vue {
  siteKey = CONFIG.siteKey;
}
